import React from 'react'
import { Image } from 'react-bootstrap';
import ciltBakimi from '../../images/home/product_cat/16002483614992.jpg';
import '../../styles/about.css'

const CiltBakimi = () => {
    return (
        <div>
            <h5 className='main-title'>Cilt Bakımı</h5>
            <hr />
            <p>Cilt bakımı bilinçsiz ve tecrübesiz ellerde istenmeyen sonuçlara yol açabilir. Cilt tipi belirlenerek yapılan aylık cilt bakımı cildin sorunlarını azaltır. Cilt problemlerinin gelişmesi engeller.&nbsp;</p>
            <p>Dermo-kozmetik ürünlerle yapılan cilt bakımı:&nbsp;</p>
            <ul>
                <li>Akneli cilt bakımı</li>
                <li>Yağlı cilt bakımı</li>
                <li>Normal cilt bakımı</li>
                <li>Hassas cilt bakımı</li>
                <li>Kuru cilt bakımı</li>
                <li>Sarkma ve kırışıklıklara karşı cilt bakımı</li>
                <li>Lekeli cilde uygun cilt bakımı</li>
                <li>Cilt dengeleyici cilt bakımı</li>
            </ul>
            <Image src={ciltBakimi} fluid className='mb-4' style={{ width: '70%' }} />
            <p>Cilt bakımı sonrası cilt yapınıza ve ihtiyacınıza en uygun cilt bakım ürünleri önerilir.&nbsp;</p>
            <p>Akneli ve yağlı ciltlere, cilt tedavileri ile birlikte ve tedavi sonrasında cilt bakımı yapılması akne sorununu çok azltabilir.&nbsp;</p>
            <p>Aylık cilt bakımı sayesinde yaşlanma etkilerini azaltabilir. Henüz sorun oluşmadan ve tıbbi müdahaleye gerek kalmadan cildinizin gençliğini ve güzelliğini cilt bakımı ile koruyabilirsiniz.</p>
        </div>
    )
}

export default CiltBakimi